export const hoverPressEffect =
  "transition-all duration-200 ease-out " +
  "hover:-translate-y-0.5 hover:shadow-md " +
  "active:translate-y-0 active:scale-[0.98] active:shadow-sm cursor-pointer";

export const hoverEffect =
  "transition-all duration-200 ease-out " +
  "hover:-translate-y-0.5 hover:shadow-md ";

export const HoverPressableCard =
  "transition-all duration-200 ease-out " +
  "hover:-translate-y-0.5 hover:shadow-md shadow-white/20 " +
  "px-[16px] rounded-2xl " +
  "active:translate-y-0 active:scale-[0.98] active:shadow-sm cursor-pointer";

export const hoverScale =
  "transition-all duration-200 ease-out " +
  "hover:-translate-y-0.5 " +
  "active:translate-y-0 active:scale-[0.98] cursor-pointer";

export const isLiked = "text-[#0057B8] ";

export const isUnLiked = "text-white ";
